export enum CaseReviewsFilterOptions {
    None = 1,
    Deleted = 2
}
